module.exports = __webpack_public_path__ + "static/reduxtitle-0696aa54c5b646340083d7051dc5f5a7.png";